import { IApolloSearchPartnersResult } from 'legacy/lut/classes/models/apollo'

import { IPartner } from 'clickNgo/entities/partner/models'

export const checkCriticalMatch = (
  apolloSearchResult: IApolloSearchPartnersResult[],
  compared: IPartner
) => {
  return apolloSearchResult.find((el) => el.partnerId === compared.partnerId)?.hasCriticalMatch
}
